import classnames from 'classnames'
import React, { FC } from 'react'

import SupportAgentIcon from '@material-symbols/svg-300/outlined/support_agent.svg'
import ApartmentIcon from '@material-symbols/svg-300/outlined/apartment.svg'
import FlagIcon from '@material-symbols/svg-300/outlined/flag.svg'
import PolicyIcon from '@material-symbols/svg-300/outlined/policy.svg'
import LocationAway from '@material-symbols/svg-300/rounded/location_away.svg'
import { User } from '../../models/User'

type UserRoleIconProps = { userRole: string; userStatus: User['status'] } & React.ComponentPropsWithoutRef<'svg'>

import styles from './UserRoleIcon.module.scss'

const userRoleIconComponents: { [k: string]: FC } = {
  advanced_user: FlagIcon,
  admin: ApartmentIcon,
  auditor: PolicyIcon,
  customer_success_manager: SupportAgentIcon,
  trainer: LocationAway,
}

export default React.memo(function UserRoleIcon({ userRole, userStatus, className, ...props }: UserRoleIconProps) {
  const Component = userRoleIconComponents[userRole] || null
  return (
    Component && (
      <div className={classnames(className, styles.UserRoleIcon, styles[userRole], styles[userStatus])}>
        <Component {...(props as any)} />
      </div>
    )
  )
})
